import { useAuth } from '@aaas/shared';
import { useMemberRoleListQuery } from './useMemberRoleQueries';

export function useATSRole() {
  const { currentWorkspace, idToken } = useAuth();
  const { data, isLoading } = useMemberRoleListQuery({
    workspaceId: currentWorkspace?.id,
    idToken: idToken || undefined,
    enabled: !!currentWorkspace,
  });
  const role = data?.currentUserRole ?? null;
  return {
    role,
    isLoading,
    isRecruiter: role === 'recruiter',
    isLeaderOrAbove: role === 'leader' || role === 'manager',
    isManager: role === 'manager',
    currentUserAccountId: data?.currentUserAccountId ?? null,
  };
}
